export const parseMessage = message => {
  const data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;
  if (!data) {
    throw new Error('Failed to parse message data');
  }
  return data;
};